import { render, staticRenderFns } from "./LabelIcon.vue?vue&type=template&id=6562ec1b&"
import script from "./LabelIcon.vue?vue&type=script&lang=js&"
export * from "./LabelIcon.vue?vue&type=script&lang=js&"
import style0 from "./LabelIcon.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VChip,VIcon})
